import React from 'react';
import { BookOpenIcon, GiftIcon, UsersIcon, WrenchIcon } from 'lucide-react';
const items = [{
  icon: BookOpenIcon,
  label: '9 comprehensive volumes'
}, {
  icon: GiftIcon,
  label: '5 exclusive bonuses'
}, {
  icon: WrenchIcon,
  label: '+450 ready-to-use resources'
}, {
  icon: UsersIcon,
  label: 'Teachers, students and educators'
}];
export function SocialProof() {
  return <section className="metal py-5" aria-label="What the teacher ready includes" data-id="element-221" data-mp="3f4w0k0myvke">
      <div className="mx-auto flex max-w-5xl flex-wrap items-center justify-center gap-x-8 gap-y-3 px-4 text-sm font-semibold text-slate-950 sm:justify-between" data-id="element-222" data-mp="3h7l91tysko2">
        {items.map(({
        icon: Icon,
        label
      }) => <span key={label} className="inline-flex items-center gap-2" data-id="element-223" data-mp="3ut99cr4s6j3l">
            <Icon className="h-5 w-5 text-slate-700" aria-hidden="true" data-id="element-224" data-mp="3urfyezn4xcps" /> {label}
          </span>)}
      </div>
    </section>;
}